import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { ConsentDataProcessing } from "../../../components/ConsentDataProcessing";
import { SocialLinks } from "../SocialLinks";
import { Countries } from "../Countries";
import { Blocks } from "./components/Blocks";
import style from "./styles.module.pcss";
import { getBlockProps } from "./components/Blocks/utils";
var cn = classNames.bind(style);
export var Desktop = /*#__PURE__*/memo(function (_ref) {
  var blocks = _ref.blocks,
    mailInput = _ref.mailInput,
    appButtonsDesktop = _ref.appButtonsDesktop,
    socialsLinks = _ref.socialsLinks,
    footer = _ref.footer,
    international = _ref.international,
    subscribeEmailURL = _ref.subscribeEmailURL,
    subscribeEmailTextAgreementURL = _ref.subscribeEmailTextAgreementURL;
  var copyrightYear = useMemo(function () {
    return new Date().getFullYear();
  }, []);
  var blocksProps = useMemo(function () {
    return getBlockProps({
      blocks: blocks,
      subscribeEmailTextAgreementURL: subscribeEmailTextAgreementURL,
      subscribeEmailURL: subscribeEmailURL,
      mailInputTexts: mailInput.texts,
      appButtonsDesktop: appButtonsDesktop
    });
  }, [blocks, subscribeEmailTextAgreementURL, subscribeEmailURL, mailInput, appButtonsDesktop]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('desktop')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('main')
  }, /*#__PURE__*/React.createElement("nav", {
    className: cn('nav')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('blocks')
  }, /*#__PURE__*/React.createElement(Blocks, {
    blocks: blocks,
    data: blocksProps
  })))), /*#__PURE__*/React.createElement("div", {
    className: cn('divider')
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('social-buttons')
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    socialsLinks: socialsLinks
  }), international && /*#__PURE__*/React.createElement(Countries, {
    international: international
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('footer')
  }, /*#__PURE__*/React.createElement(ConsentDataProcessing, {
    personalDataButtonText: footer.personalDataButtonText,
    personalDataTextFirst: footer.personalDataTextFirst,
    personalDataTextSecond: footer.personalDataTextSecond,
    policyModalButton: footer.policyModalButton,
    policyModalText: footer.policyModalText,
    policyModalTitle: footer.policyModalTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('footer__bottom-side')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('footer__site-map')
  }, /*#__PURE__*/React.createElement("a", {
    className: cn('footer__link'),
    href: "/customers/site-map/"
  }, footer.siteMap), /*#__PURE__*/React.createElement("div", {
    className: cn('footer__copyright')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size7-r"
  }, footer.copyrightBeeline, copyrightYear))))));
});